import { styled } from 'styled-components';

import { PrimaryButton } from 'brand-guidelines/Buttons-styled-components';
import { BRAND_COLORS } from 'brand-guidelines/colors';
import { TYPOGRAPHY } from 'brand-guidelines/typography';
import { LabeledInput } from 'pages/checkout/components/common/LabeledInput/LabeledInput';
import { TextStyle } from 'pages/checkout/components/common/LabeledInput/LabeledInput-styled-components';
import { StepWrapper } from 'pages/checkout/components/common/layout-styled-components';
import { BaseBodyText } from 'pages/checkout/components/common/typographic-styled-components';
import { AlignItems, FlexDirection, JustifyContent } from 'types/CSS';

interface ConfirmStepWrapperProps {
  $hasDisclaimer?: boolean;
}

export const ConfirmStepWrapper = styled(StepWrapper)<ConfirmStepWrapperProps>`
  align-items: stretch;
  /* Accounts for the fixed submit button */
  padding-bottom: ${({ $hasDisclaimer }) => $hasDisclaimer ? '130px' : '100px'};
`;

export const DetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const DetailText = styled.span`
  ${TYPOGRAPHY.OPEN_SANS.base}
  color: ${BRAND_COLORS.darkGray};
  font-size: 14px;
  line-height: 24px;
`;

export const PracticeDetails = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
`;

export const PracticeTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StatusBadgesWrapper = styled.div`
  display: flex;
  gap: 8px;
`;

export const ProfilePhoto = styled.img`
  height: 46px;
  aspect-ratio: 1;

  border-radius: 100%;
  object-fit: cover;

  margin-right: 16px;

  outline: 1px solid ${BRAND_COLORS.stroke};
  outline-offset: 1px;
`;

export const AcknowledgementsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const GiftCardText = styled(BaseBodyText).attrs({ as: 'span' })`
  ${TYPOGRAPHY.OPEN_SANS.semiBold}
`;

const SUBMIT_WRAPPER_HEIGHT = 83;
const SUBMIT_WRAPPER_HEIGHT_WITH_DISCLAIMER = 110;

export const SubmitWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: stretch;

  min-height: ${SUBMIT_WRAPPER_HEIGHT}px;
  margin-top: 16px;
`;

interface SubmitRequestWrapperProps {
  $hasDisclaimer?: boolean;
}

export const SubmitRequestWrapper = styled.div<SubmitRequestWrapperProps>`
  display: flex;

  position: fixed;
  bottom: 0;
  left: 0;

  flex-direction: column;
  align-items: center;
  gap: 8px;

  height: ${({ $hasDisclaimer }) => $hasDisclaimer ? SUBMIT_WRAPPER_HEIGHT_WITH_DISCLAIMER : SUBMIT_WRAPPER_HEIGHT}px;
  width: 100%;

  padding: 16px;

  border-top: 1px solid ${BRAND_COLORS.stroke};
  background: ${BRAND_COLORS.white};
  box-shadow: 0px -8px 8px 0px rgba(0, 0, 0, 0.08);

  background-color: ${BRAND_COLORS.white};
`;

export const SubmitRequestButton = styled(PrimaryButton)`
  width: 100%;
  max-width: 485px;
`;

export const CheckboxLabeledInput = styled(LabeledInput).attrs({
  direction: FlexDirection.ROW_REVERSE,
  alignItems: AlignItems.CENTER,
  justifyContent: JustifyContent.END,
  textStyle: TextStyle.REGULAR,
})``;
